export default {
  tabbar1: "Home",
  tabbar2: "Community",
  tabbar3: "Choose",
  tabbar4: "Hotel",
  tabbar5: "Mine",
  login: "Login",
  userNamePlaceholder: "Please enter phone number",
  passwordPlaceholder: "Please enter password",
  forgotPassword: "Forgot password?",
  noAccount: "No account?",
  registerNow: "Register now",
  register: "Register",
  inviteCodeePlaceholder: "Please enter invite code",
  consentAgreement:
    "I have read and agree to the account agreement and transaction terms",
  highEndZone: "High-end Zone",
  EnjoyTheUltimateLuxuryExperience: "Enjoy the ultimate luxury experience",
  airborne: "Yes",
  viewMoreData: "View more",
  aboutCannonRecommend: "Recommended connections",
  current: "Current",
  peopleNowMatch: "People are online and matching",
  accountMembership: "Dating Card activated",
  highEnd: "Gr8",
  authentication: "Auth",
  videoAuthentication: "Video Auth",
  tollRange: "Charge range",
  personHeight: "Height",
  bust: "Bust",
  serviceCity: "Service city",
  nationalAirborne: "National air freight",
  askHerOut: "Ask her out",
  uptodate: "Latest",
  play: "Play",
  reservation: "Reservation",
  beautifulGirl: "Beautiful girl",
  people: "People",
  requiredPromotion: "Required promotion",
  integral: "Points",
  rechargePoints: "Recharge",
  redeemPoints: "Redeem",
  myActivityPoints: "My activity points",
  currencySymbol: "Currency symbol",
  basicInformation: "Basic information",
  personalReports: "Personal reports",
  loginPassword: "Login password",
  paymentPassword: "Payment password",
  taskLog: "Task log",
  Fundingdetails: "Funding details",
  noticeAnnouncement: "Announcement",
  onlineService: "Customer service",
  logOut: "Log out",
  residence: "Residence",
  reservationNow: "Reserve now",
  photo: "Photo",
  video: "Video",
  personalProfile: "Personal profile",
  popularRecommendations: "Popular recommendations",
  switchWindows: "Switch windows",
  designatedTime: "Designated time",
  votingResults: "Voting results",
  ISSUE: "Issue number",
  data: "Lottery data",
  big: "Big",
  small: "Small",
  one: "One",
  two: "Two",
  currentSelectedNumber: "Currently selected number",
  pointsPerOrder: "Points per order",
  inTotal: "Total",
  amountMoney: "Amount",
  availablePoints: "Available points",
  submitTo: "Submit",
  artilleryEngagement: "Date activity",
  recharge: "Recharge",
  Withdrawal: "Withdrawal",
  AccountDetails: "Account details",
  SystemOperation: "System operation",
  payeeName: "Payee name",
  bankName: "Payment Account Number",
  bankCardNumber: "Bank card number",
  bankCardNumberPlaceholder: "Please enter bank card number",
  branchName: "Branch name",
  branchNumber: "Branch number",
  selectBank: "Please fill in your Payment Account information",
  nameOfPayer: "Payer name",
  uploadPaymentVoucher: "Upload payment voucher",
  rechargePrompt:
    "Do not repeat the operation. If not credited for a long time, please contact customer service.",
  confirmRecharge: "Confirm recharge",
  exchangeRecords: "Exchange records",
  whole: "All",
  limitDescription: "Limit description",
  singleTransactionLimit: "Single transaction limit",
  minimum: "Minimum",
  highest: "Highest",
  withdrawalFrequency: "Withdrawal frequency",
  dailyHighest: "Daily highest",
  order: "Order",
  freeOfHandlingFees: "(Free of handling fees for up to 500 transactions)",
  receiptTime:
    "Receipt time: Generally arrives in about 5 minutes, fastest in 2 minutes.",
  residualIntegral: "Remaining points",
  individual: "Individual",
  redeemPointsNow: "Redeem now",
  headSculpture: "Profile picture",
  fullName: "Payee Name",
  gender: "Gender",
  male: "Male",
  female: "Female",
  unknown: "Unknown",
  bankCardInformation: "Payment Account",
  have: "Have",
  notHave: "Do not have",
  modifyRealName: "Modify real name",
  save: "Save",
  fullNamePlaceholder: "Please enter real name",
  modifyRealNameRemake:
    "To ensure account security, the name must match the name on the linked bank card.",
  modifyGender: "Modify gender",
  cardNumber: "Bank card number",
  cardName: "Account holder",
  cardID: "Bank account number",
  addBankCard: "Add Payment Account",
  addBankCardRemake:
    "Tips: Please add your Payment Account. If you need to modify it, please contact online customer service.",
  addBankCardRemake2:
    "Friendly Reminder: When contacting customer service to make a PayPal deposit To avoid improper transactions with girls and unnecessary legal risks, this platform only accepts PayPal “Friends and Family” payments under the context of a romantic relationship. Commercial payments will be considered invalid and will not be processed by the platform.",
  payCardInfoPlaceholder: "Please enter your Payment Account information",
  addBankCardPrompt:
    "For the safety of your funds, please fill in your Payment Account number correctly and set a withdrawal password. Filling in the wrong information will result in your funds not being able to be received on time!",
  personalReport: "Personal report",
  profitPoints: "Profit points",
  profiCalculationFormula:
    "Profit calculation formula: Winning points - Task points",
  taskPoints: "Task points",
  withdrawalPoints: "Withdrawal points",
  winningPoints: "Winning points",
  changeLoginPassword: "Change login password",
  oldPwd: "Old password",
  oldPwdPlaceholder: "Please enter old password",
  newPwd: "New password",
  newPwdPlaceholder: "Please enter new password",
  againOldPwdPlaceholder: "Please enter new password again",
  taskRecord: "Task record",
  emptyData: "No data",
  betPoints: "Bet points",
  orderTime: "Order time",
  settlementTime: "Settlement time",
  refreshSuccessful: "Refresh successful",
  invalidFunction: "This function is invalid",
  appointmentSuccessful: "Appointment successful",
  completeActivationTask:
    "Please contact customer service to obtain the appointment card.",
  checkAgreement: "Please check the account agreement.",
  integralError: "Points error",
  selectNumber: "Please select a number",
  fillInPoints: "Please enter points",
  txjebndyye:
    "The withdrawal amount cannot be greater than the account balance",
  insufficientPoints: "Insufficient points, please contact customer service.",
  contactCollect: "Please contact the administrator to receive this task.",
  successfulLotteryDraw: "Lottery draw successful, issue number:",
  notSet: "Not set",
  contactService:
    "Please contact customer service if you need to change the password.",
  completeTask: "Please complete the task order and fill it out as required.",
  setUpBankCard: "Please set up a bank card",
  accountOffline: "Account offline",
  fileTooLarge: "File too large",
  formatRule: "Please upload the image in the correct format.",
  uploadSuccessful: "Upload successful",
  amountError: "Amount error",
  setNameToBindBankCard: "Please set your name and bind the bank card.",
  setWithdrawalPasswordToBindBankCard:
    "Please set the withdrawal password and bind the bank card.",
  passwordInconsistency: "Password inconsistency",
  complete: "Please complete all information.",
  changWithdrawalPasswordContactSustomerService:
    "The withdrawal password has been set, please contact customer service to make changes.",
  activateWatchVideo: "You can watch the video after completing the task",
  rechargeWatchVideo: "You can watch the video after recharging",
  pour: "Bet",
  taskList: "Task list",
  clearOrder: "Clear order",
  confirmSub: "Confirm submit",
  switchLanguage: "Switch language",
  illustrate: "Explanation",
  submissionTime: "Submission time",
  auditTime: "Audit time",
  oldPayPwd: "Old payment password (default is 0000)",
  payPwdPl: "Please enter payment password",
  enterPayPwdPl: "Please enter payment password again",
  setPayPwd: "Set payment password",
  yse: "Yes",
  creditScore: "Credit score",
  sdintroduce:
    "Domestic and international travel at the leading platform for accommodation bookings. Hotels, flights, and more fully covered, enjoy discounts!",
  Membershipincome: "Membership income",
  Balance: "Balance",
  Income: "Income today",
  Totaldeposit: "Number of tasks",
  Totalwithdrawal: "Total income",
  GrabOrder: "Start verification",
  popularRestaurant: "Popular hotels",
  Restaurantname: "Hotel name",
  Totalamount: "Total amount",
  Commission: "Commission",
  Ordernumber: "Order number",
  Submissiontime: "Submission time",
  Submit: "Submit",
  History: "History",
  All: "All",
  Pending: "Pending",
  Completed: "Completed",
  Pay: "Pay",
  reviews: "Reviews",
  MAD: "$",
  includestaxescharges: "Includes taxes and service charges",
  Expectedreturn: "Expected return",
  Detail: "Detail",
  freeze: "Freeze",
  OrderQuantity: "Order quantity",
  OrderQuantityTxt: "Order system generated: single or multiple",
  loadingtext: "Loading",
  finishedtext: "No more data",
  pullingtext: "Pull to refresh",
  loosingtext: "Release to refresh",
  Payremainingtime: "Pay remaining time",
  trade: "Trade",
  Rebate: "Rebate",
  ForcedTransaction: "Forced transaction",
  PromotionRebate: "Promotion rebate",
  Subleveltransactionrebate: "Sublevel transaction rebate",
  Rules: "Rules",
  confirmButtonText: "Confirm",
  CreditScore: "Credit score",
  VerifyDECardNumber:
    "Please link an international bank account starting with DE.",
  AdultVideos: "18+ Welfare Channel",
  v0tips1: "Successful Match",
  v0tips2:
    "To celebrate your sweet first meeting, our platform sponsors will provide a complimentary one-night stay in a luxury couple’s suite as an exclusive benefit for your first offline date",
  v0tips3: "A Selection of Our Partner Luxury Hotels",
  serviceTip:
    "You must contact the platform's customer service via Telegram or WhatsApp to apply for a date with a girl and get her contact information.",
  DefaultPassword: "The default initial password is 0000",
  PassionateMovies: "Passionate Movies",
  acshop: "Love Nest Mall",
  yishou: "Sold",
  qsrssgjc: "Please enter the product name.",
  searchtxt: "search",
  spxq: "Product Details",
  spms: "Product Description",
  acordertit: "Latest purchase",
  buytit: "Buy",
  jinetit: "Total",
  goumaile: "Purchased",
  buysuccess: "Order placed",
  buysuccesstxt: "Please contact customer service to confirm!",
  cancelButtonText: "Cancel",
};
